import BaseClass from "../BaseClass";

export default class Collapse extends BaseClass {

    constructor(element) {
        super(element);

        this.container = null;
        this.$container = null;
        this.bsCollapse = null;

        this.$collapseHandler = null;
        this.onCollapsing = null;
        this.hideOnBodyClick = null;
        this.hideListener = null;

        this.toggle = false; // initialer zustand des containers (true = zugeklappt, false = aufgeklappt)

        this.init();
    }

    init() {
        const mySelf = this;
        this.$container = this.$element.find('[data-type="collapse-container"]');
        this.container = this.$element.find('[data-type="collapse-container"]').get(0);

        const collapseHandler = this.$element.find('[data-type="collapsehandler"]');
        if (collapseHandler) {
            this.$collapseHandler = collapseHandler;
        }

        // container initial aufklappen
        this.toggle = this.$element.data('toggle');

        this.onCollapsing = function () {
            const $customLoadElement = mySelf.$element.find('[data-custom-load="true"]');

            if ($customLoadElement.length) {
                $customLoadElement.trigger('custom:load', {
                    id: $customLoadElement.attr('id')
                });
            }

            mySelf.container.removeEventListener('show.bs.collapse', mySelf.onCollapsing);
        };

        this.bsCollapse = new bootstrap.Collapse('#' + this.$container.attr('id'), {
            toggle: mySelf.toggle
        });

        this.showListener = function (event) {
            event.stopPropagation();
            mySelf.closeAllOthers();
            mySelf.show();
            mySelf.toggleHandlerText('show');
        }

        this.hideListener = function (event) {
            mySelf.hide(event);
            mySelf.toggleHandlerText('hide');
        }

        this.$collapseHandler.on('click', this.showListener);
        this.container.addEventListener('show.bs.collapse', this.onCollapsing);

        this.hideOnBodyClick = Boolean(this.$element.data('hide-on-body-click'));

        this.$element.data('collapseInstance', this);
    }

    show() {
        const windowHeight = window.innerHeight;
        const elementRect = this.$collapseHandler[0].getBoundingClientRect();
        const dropdownHeight = this.container.scrollHeight || 280;
        const spaceBelow = windowHeight - elementRect.bottom;

        if (spaceBelow <= dropdownHeight) {
            this.$container.addClass('open-up');
        } else {
            this.$container.removeClass('open-up');
        }

        this.bsCollapse.show();
        this.$collapseHandler.off('click', this.showListener);
        this.$collapseHandler.on('click', this.hideListener);

        if (this.hideOnBodyClick) {
            $('body').on('click', this.hideListener);
        }
    }

    hide() {
        this.bsCollapse.hide();
        this.$collapseHandler.off('click', this.hideListener);
        this.$collapseHandler.on('click', this.showListener);

        if (this.hideOnBodyClick) {
            $('body').off('click', this.hideListener);
        }
    }

    closeAllOthers() {
        const currentDropdownGroup = this.$element.data('dropdown-group');
        const allDropdowns = document.querySelectorAll('[data-dropdown-group]');

        allDropdowns.forEach((dropdown) => {
            const dropdownGroup = $(dropdown).data('dropdown-group');
            const instance = $(dropdown).data('collapseInstance');

            if (instance && instance != this && dropdownGroup == currentDropdownGroup) {
                instance.hide();
            }
        });
    }

    toggleHandlerText(state) {
        if (typeof this.$collapseHandler.data('text-show') !== 'undefined' &&
            typeof this.$collapseHandler.data('text-hide') !== 'undefined'
        ) {
            this.$collapseHandler.html(this.$collapseHandler.attr('data-text-' + state));
        }
    }

    destroyListener() {
        if (this.hideOnBodyClick) {
            $('body').off('click', this.hideListener);
        }

        this.container.removeEventListener('show.bs.collapse', this.onCollapsing);
        if (this.$collapseHandler != null) {
            this.$collapseHandler.off('click', this.showListener);
            this.$collapseHandler.off('click', this.hideListener);
        }
    }
}